import { BoxProps } from "@mui/material";
import { forwardRef, PropsWithChildren } from "react";
import { Col, Row } from "v2/components/base/Flex/ui";
import { useCheckViewPoint } from "hooks/useCheckViewPoint";

const ScrollableWrapper = forwardRef(({ children, ...props }: PropsWithChildren<BoxProps>, ref) => {
  const isMobile = useCheckViewPoint({ to: "md" });

  return (
    <Col
      sx={{
        gap: "6px",
        height: isMobile ? "100vh" : "calc(100vh - 200px)",
        minHeight: 0,
        overflowY: "scroll",
        overflowX: "hidden",
        "*::-webkit-scrollbar": {
          display: "none",
        },
        "*::-webkit-scrollbar-track": {
          display: "none",
        },
        "*::-webkit-scrollbar-thumb": {
          display: "none",
        },
      }}
      ref={ref}
      fullWidth
      fullHeight
      // boxRef={ref}
      {...(props as any)}>
      {children}
      {isMobile && <Row sx={{ minHeight: "140px" }} fullWidth />}
    </Col>
  );
});

export default ScrollableWrapper;
